export default {
    form: () => import('./PaymentMethodCardForm'),

    inputs: {
        name: () => import('./Inputs/PaymentMethodCardForm_Name'),
        card: () => import('./Inputs/PaymentMethodCardForm_Card')
    }
}